import { Component, computed, effect, input, signal } from '@angular/core';
import { reviewerAvatarHue, reviewerInitials } from '../../commons/reviewer-avatar.utils';

export type ReviewerAvatarSize = 'sm' | 'md' | 'lg';

@Component({
  selector: 'app-reviewer-avatar',
  standalone: true,
  templateUrl: './reviewer-avatar.component.html',
  styleUrl: './reviewer-avatar.component.scss',
})
export class ReviewerAvatarComponent {
  readonly name = input.required<string>();
  readonly photoUrl = input<string | null>(null);
  readonly size = input<ReviewerAvatarSize>('md');

  readonly photoFailed = signal(false);

  readonly initials = computed(() => reviewerInitials(this.name()));
  readonly hue = computed(() => reviewerAvatarHue(this.name()));
  readonly label = computed(() => `${this.name()} avatar`);
  readonly showPhoto = computed(() => Boolean(this.photoUrl()) && !this.photoFailed());

  constructor() {
    effect(() => {
      this.photoUrl();
      this.photoFailed.set(false);
    });
  }

  onPhotoError = (): void => {
    this.photoFailed.set(true);
  };
}